import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import BrandingHeader from './components/BrandingHeader';
import LoginForm from './components/LoginForm';
import SecurityBadge from './components/SecurityBadge';
import Icon from '../../components/AppIcon';

const AdminLogin = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin-dashboard');
    }
  }, [isAuthenticated, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4 md:p-6 lg:p-8">
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"></div>
      </div>
      <div className="w-full max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12">
          <div className="flex flex-col justify-center">
            <div className="w-full max-w-md mx-auto lg:mx-0">
              <BrandingHeader />

              <div className="bg-card rounded-2xl p-6 md:p-8 border border-primary/20 glow-primary">
                <div className="mb-6">
                  <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground mb-2">
                    Bem-vindo de volta
                  </h2>
                  <p className="text-sm text-muted-foreground">
                    Faça login para acessar o painel administrativo
                  </p>
                </div>

                <LoginForm />
              </div>

              <div className="mt-6 text-center">
                <button
                  onClick={() => navigate('/home-gallery')}
                  className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-smooth focus-ring rounded-md px-3 py-2"
                >
                  <Icon name="ArrowLeft" size={16} />
                  <span>Voltar para Galeria</span>
                </button>
                <button
                  onClick={() => navigate('/')}
                  className="inline-flex items-center gap-2 text-sm text-muted-foreground hover:text-primary transition-smooth focus-ring rounded-md px-3 py-2 ml-4"
                >
                  <Icon name="Home" size={16} />
                  <span>Voltar para Home</span>
                </button>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex flex-col justify-center">
            <div className="w-full max-w-md mx-auto">
              <SecurityBadge />

              <div className="mt-8 p-6 rounded-2xl bg-gradient-to-br from-primary/10 to-secondary/10 border border-primary/20">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0 glow-primary">
                    <Icon name="Sparkles" size={24} color="var(--color-primary)" />
                  </div>
                  <div className="flex-1">
                    <h3 className="text-lg font-heading font-bold text-foreground mb-2">
                      Recursos Administrativos
                    </h3>
                    <ul className="space-y-2 text-sm text-muted-foreground">
                      <li className="flex items-start gap-2">
                        <Icon name="Check" size={16} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
                        <span>Gerenciamento completo de conteúdo</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Icon name="Check" size={16} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
                        <span>Personalização de marca e cores</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Icon name="Check" size={16} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
                        <span>Análise de métricas e desempenho</span>
                      </li>
                      <li className="flex items-start gap-2">
                        <Icon name="Check" size={16} color="var(--color-secondary)" className="flex-shrink-0 mt-0.5" />
                        <span>Sistema de marca d'água customizável</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="mt-6 flex items-center justify-center gap-4 text-xs text-muted-foreground">
                <span className="flex items-center gap-1">
                  <Icon name="Clock" size={14} />
                  Sessão segura
                </span>
                <span className="w-1 h-1 rounded-full bg-muted-foreground"></span>
                <span className="flex items-center gap-1">
                  <Icon name="Globe" size={14} />
                  Acesso global
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date()?.getFullYear()} UP MIDIA. Todos os direitos reservados.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AdminLogin;